import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function RiskUnsoldMerchant() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [message, setMessage] = useState("")
    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [combineList, setCombineList] = useState([])
    const [reload, setReload] = useState(false)

    // ▼ 탭 상태 (가맹점 수정 / 정산주기 / PG정보)
    const [activeTab, setActiveTab] = useState("수기결제")
    const [listState, setListState] = useState(false)

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 검색구분 포맷
    const select4 = ["가맹점명", "가맹점아이디"]

    const [selectedValue3, setSelectedValue3] = useState("가맹점명");
    const [selectedText3, setSelectText3] = useState("")

    const handleSelectChange3 = (event) => {
        const value = event.target.value;
        setSelectedValue3(value);
    };

    const handleSelectTextChange3 = (event) => {
        const value = event.target.value;
        setSelectText3(value);
    };

    // 검색 버튼
    const submit = () => {
        setReload(e => !e)
    }

    useEffect(() => {
        dispatch(change_Current_Location("무실적가맹점"))
        dispatch(changeHeaderTitle({
            mainTitle: "무실적가맹점"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    useEffect(() => {
        ListData()
    }, [page, reload])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        await axios.get(process.env.REACT_APP_API + "/api/rm/inactive-merchants", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.inactive_merchants ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.inactive_merchants ?? []]);
                }
                setListState(e => !e)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
        });
    }

    const tableHeaderData = [
        { "no": 2, "text": "MID", "width": "100px", "textAlign": "center" },
        { "no": 3, "text": "영업자", "width": "120px", "textAlign": "center" },
        { "no": 4, "text": "가맹점명", "width": "200px", "textAlign": "center" },
        { "no": 5, "text": "가맹점주", "width": "80px", "textAlign": "center" },
        { "no": 7, "text": "생성일", "width": "150px", "textAlign": "center" },
        { "no": 7, "text": "마지막거래일", "width": "150px", "textAlign": "center" }
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listTrxData) {
            setCombineList(listTrxData)
            for (let i = 0; i < listTrxData.length; i++) {
                let data = listTrxData[i]

                // let date = data.createdAt.split('T')
                // let date1 = date[1].split('.')

                tableBodyData.push([
                    { "no": 2, "text": data.mid, "width": "100px", "textAlign": "left" },
                    { "no": 3, "text": data.agent_nm, "width": "120px", "textAlign": "left" },
                    { "no": 4, "text": data.co_nm, "width": "200px", "textAlign": "left" },
                    { "no": 5, "text": data.boss_nm, "width": "80px", "textAlign": "center" },
                    { "no": 7, "text": data.reg_dt, "width": "150px", "textAlign": "center" },
                    { "no": 7, "text": data.last_transaction_date, "width": "150px", "textAlign": "center" }
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [listTrxData, page, maxFirstPage, reload])

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                    {/* {<SearchSelectText type={"검색구분"} selectData={select4} handleSelectChange={handleSelectChange3} selectedValue={selectedValue3} handleSelectTextChange={handleSelectTextChange3} selectedText={selectedText3} btnText={"검색"} onClick={() => submit()} />} */}

                </form>
            </div>
            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row", marginBottom: "10px" }}>
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', margin: "0", width: "100%", gap: "10px" }}>
                        <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                            <label>거래수 :</label>
                            <input id="instant_terminal_amt" type="text" className="form-control" value={`${listData?.totCnt ?? 0}개`} readonly="" disabled="" />
                        </div>
                    </div>
                </div>
                <div className="div-flex-2 contents" style={{ gap: "20px" }}>
                    <div style={{ width: "100%", maxWidth: "800px" }}>
                        {/* <div className='div-flex-1-1' style={{ width: MyData?.role == "SUPER" ? "" : "100%", }}> */}
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={listData?.totCnt ?? 0}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            observerRef={observerRef}
                            nonePage={false}
                            scrollState={true}
                            height={"820px"}
                            spinner={spinner}
                        />
                    </div>

                    {/* {
                        MyData?.role == "SUPER"
                            ?
                            <div className='mt-3 div-flex-1-2' style={{ display: "flex", padding: "16px", backgroundColor: clickData?.id ? "rgb(69 69 69)" : "" }}>
                                <div className='div-flex-1-3' style={{ backgroundColor: "#fff" }}>
                                    <div style={{ padding: "10px" }}>
                                        <div>
                                            <PayInfo
                                                key={clickData?.id || ""}
                                                setMessage={setMessage}
                                                clickData={clickData}
                                                setReload={setReload}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            ""
                    } */}
                </div>
            </div>
        </div>
    )
}

function PayInfo({ clickData, setMessage, setReload }) {
    const [isCancelling, setIsCancelling] = useState(false);

    const onCheckData = async () => {
        // 이미 API 호출 중이면 재진입 방지
        if (isCancelling) return;

        if (window.confirm("승인하시겠습니까?") === true) {
            setIsCancelling(true); // API 호출 시작 전 true
            try {
                await axios.post(process.env.REACT_APP_API + "/api/rm/check", {
                    riskId: clickData.riskId,
                }, {
                    withCredentials: true,
                }).then((response) => {
                    let tmp = response?.data
                    console.log(tmp)
                    if (tmp?.code < 2000) {
                        setMessage({ msg: "성공했습니다." })
                        setReload(e => !e)
                    }
                    else {
                        setMessage({ msg: tmp?.msg ?? "실패했습니다." })
                    }
                }).catch(error => {
                    console.error(error);
                });
            } finally {
                setIsCancelling(false);
            }
        }
    }

    return (
        <div style={{ padding: "5px" }}>
            {/* <div id="payment-modal" className="modal" tabindex="-1" > */}
            <div className="modal-dialog" style={{ top: "10%" }}>
                <div className=" marginTop30 modal_sty">
                    <div style={{ padding: '0 0 0.5rem', height: "645px", overflowY: "auto", fontSize: "12px" }}>
                        <div className="list-info-box">
                            <div className="box-gap">
                                <div className="gap" style={{ borderTop: "1px solid #e1e1e1" }}>
                                    <ul>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>거래아이디</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.trx_id ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>잔액</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.total_amt ? changeNum(clickData?.total_amt ?? 0) : ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>취소금액</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.cancel_price ? changeNum(clickData?.cancel_price ?? 0) : ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>거래일시</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}> {clickData?.trx_date ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>취소일시</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}> {clickData?.cancel_date ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>카드사</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.card ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>카드번호</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>  {clickData?.card_num ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>승인번호</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.approval_id ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>할부기간</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.quota ? `${clickData?.quota ?? ""}개월` : ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>승인금액</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}> {clickData?.total_amt ? changeNum(clickData?.total_amt ?? 0) : ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>주문번호</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.order_id ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>상품명</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}> {clickData?.product_name ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>구매자명</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}> {clickData?.buyer_name ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>전화번호</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.phone ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>이메일</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.email ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>정산예정일</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.settlement_date ?? ""}</span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="inner" style={{ width: "100%" }}>
                                                <span className="left-text" style={{ width: "100px" }}>정산예정금액</span>
                                                <span className="right-text" data-id="CARD_NO" style={{ width: "calc(100% - 100px)" }}>{clickData?.settlement_amount ? changeNum(clickData?.settlement_amount ?? 0) : ""}</span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {
                            clickData?.status == "위험"
                                ?
                                <div className="modal-footer" style={{
                                    border: "none", paddingLeft: "0", paddingRight: "0",
                                }}>
                                    <button
                                        type="button"
                                        className="btn btn-primary w-20 reg_btn"
                                        onClick={() => onCheckData()}
                                    >
                                        승인
                                    </button>
                                </div>
                                :
                                ""
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RiskUnsoldMerchant